const Pages=[
    {
        id: 1,
        name: "W-ORT",
        image: "https://res.cloudinary.com/dke9xzbl6/image/upload/v1656424643/portfolio%20sites/W-ORT_zdpnlc.png",
        github: "https://github.com/AmreetKumarkhuntia",
        link: "https://github.com/AmreetKumarkhuntia",
        description: ""
    },
    {
        id: 2,
        name: "H-API",
        image: "https://res.cloudinary.com/dke9xzbl6/image/upload/v1656427935/portfolio%20sites/Hapi_z0vpzk.png",
        github: "https://github.com/AmreetKumarkhuntia",
        link: "https://github.com/AmreetKumarkhuntia",
        description: ""
    },
    {
        id: 3,
        name: "foomdies",
        image: "https://res.cloudinary.com/dke9xzbl6/image/upload/v1656427936/portfolio%20sites/foomdies_fv5bv3.png",
        github: "https://github.com/AmreetKumarkhuntia",
        link: "https://github.com/AmreetKumarkhuntia",
        description: ""
    },
    {
        id: 4,
        name: "Zete",
        image: "https://res.cloudinary.com/dke9xzbl6/image/upload/v1656427936/portfolio%20sites/zete_mkk1xn.png",
        github: "https://github.com/AmreetKumarkhuntia",
        link: "https://github.com/AmreetKumarkhuntia",
        description: ""
    },
    {
        id: 5,
        name: "Music Site",
        image: "https://res.cloudinary.com/dke9xzbl6/image/upload/v1656427936/portfolio%20sites/Music_app_c4hxii.png",
        github: "https://github.com/AmreetKumarkhuntia",
        link: "https://github.com/AmreetKumarkhuntia",
        description: ""
    }
]

export {Pages};